module.exports = __webpack_public_path__ + "img/message-sent.543d1f50.svg";